import { create } from 'zustand';

import type { TenantConfig } from '~/constants/config/tenant';

interface TenantState {
  config: TenantConfig | null;
}

interface TenantActions {
  setTenantConfig: (config: TenantConfig) => void;
  clearTenantConfig: () => void;
}

/** Tenant store — NOT persisted. In-memory only, fetched post-auth. */
export const useTenantStore = create<TenantState & TenantActions>()((set) => ({
  config: null,

  setTenantConfig: (config) => {
    set({ config });
  },

  clearTenantConfig: () => {
    set({ config: null });
  },
}));
